import ErrorBase from './ErrorBase';

export default function Error504() {
    return (
        <ErrorBase
            title="Well this is embarrassing"
            subtitle="Don't worry, the dev squad is being assembled. We'll peek under the hood and take a look."
            illustration={<Illustration />}
        />
    );
}

function Illustration() {
    return (
        <svg viewBox="0 0 1080 875">
            <defs>
                <clipPath id="error502__clip-path">
                    <path
                        d="M363.92 306.06h376.76a11.06 11.06 0 0111.06 11.06V693a11.06 11.06 0 01-11.06 11H363.92a10.15 10.15 0 01-10.15-10.15V316.2a10.15 10.15 0 0110.15-10.14z"
                        strokeWidth={6}
                        strokeMiterlimit={15}
                        stroke="#2e3142"
                        fill="#ebfaf6"
                    />
                </clipPath>
                <style>
                    {
                        '.error502__cls-2{fill:#ebfaf6}.error502__cls-3{fill:#c0f0e8}.error502__cls-5,.error502__cls-7{fill:none;stroke:#c0f0e8;stroke-miterlimit:10;stroke-width:2px}.error502__cls-7{stroke:#ebfaf6}.error502__cls-10{fill:#1aa495}.error502__cls-11{fill:#e94d72}.error502__cls-13{fill:#2e3142}'
                    }
                </style>
            </defs>
            <path
                className="error502__cls-2"
                d="M84.29 859C74.33 847.14 18 778 72 707c25.69-33.78-117-191 24-271 45.92-26.06 5.67-119.07 6-158 .42-49.15 26.37-97.24 62-130.94 33.74-31.9 85-37.16 130.84-30.06s244 53.2 296.84 30.84c51.15-21.62 98-52.23 152.38-66.15 41.48-10.62 85.13-8.21 127.65-3.19C894.44 81.18 951 99 971.83 141.79 992.57 184.38 963 235 1014 284c25.31 24.31 49 47.15 44 130-7 115-68.53 203.31-42 262 33 73 13 139-21.16 182.87"
                id="error502__BG"
            />
            <g id="error502__Layer_2" data-name="Layer 2">
                <path
                    className="error502__cls-3"
                    d="M997.09 320.06h-58v14.49h49.12a8.84 8.84 0 018.84 8.84v89.08a8.33 8.33 0 01-8.34 8.33h-85.32v14.49h93.7a14.49 14.49 0 0014.49-14.49V334.55a14.49 14.49 0 00-14.49-14.49z"
                />
                <circle
                    className="error502__cls-3"
                    cx={773.96}
                    cy={749.9}
                    r={71.48}
                />
                <circle
                    className="error502__cls-2"
                    cx={773.96}
                    cy={749.9}
                    r={50.23}
                />
                <rect
                    className="error502__cls-3"
                    x={864.27}
                    y={747.49}
                    width={57.96}
                    height={54.09}
                    rx={3.29}
                />
                <path
                    d="M919.4 571.47l-19.76 204.7c-.75 4.25-2.78 5.38-5.87 5.62h-.08a5.94 5.94 0 01-6.09-5.33l-24.54-206.14"
                    strokeWidth={1.98}
                    strokeMiterlimit={10}
                    stroke="#c0f0e8"
                    fill="none"
                />
                <path
                    className="error502__cls-3"
                    d="M953.59 425.8l-12.42-24.91-15.07 7.52a62.22 62.22 0 00-15.79-13.72l5.34-16-26.39-8.83-5.34 16a61.88 61.88 0 00-20.86 1.45l-7.52-15.07-24.9 12.43 7.51 15.06a62.37 62.37 0 00-13.71 15.79l-16-5.34-8.83 26.39 16 5.34a62.22 62.22 0 001.46 20.87L802 470.3l12.42 24.9 15.07-7.51a62 62 0 0015.79 13.71l-5.34 16 26.39 8.82 5.34-16a62.14 62.14 0 0020.86-1.45l7.52 15.06L925 511.42l-7.51-15.06a62.37 62.37 0 0013.71-15.79l16 5.34 8.8-26.39-16-5.35a62.18 62.18 0 00-1.46-20.86z"
                />
                <circle
                    className="error502__cls-2"
                    cx={877.8}
                    cy={448.05}
                    r={28.65}
                />
                <path
                    className="error502__cls-3"
                    d="M999.32 480L986 473.65l-3.86 8.08a33 33 0 00-11.1-.6l-3-8.44-13.95 4.92 3 8.45a32.76 32.76 0 00-8.27 7.43l-8.07-3.87-6.41 13.38 8.07 3.86a33.09 33.09 0 00-.6 11.11l-8.45 3 4.91 14 8.45-3a32.87 32.87 0 007.41 8.27l-3.86 8.08 13.33 6.38 3.87-8.07a33 33 0 0011.09.59l3 8.45 14-4.93-3-8.44a33.36 33.36 0 008.28-7.43l8.06 3.86 6.39-13.35-8.06-3.86a33 33 0 00.6-11.1l8.44-3-4.91-14-8.44 3a32.91 32.91 0 00-7.42-8.27z"
                />
                <ellipse
                    className="error502__cls-2"
                    cx={974.79}
                    cy={514.14}
                    rx={15.23}
                    ry={15.22}
                    transform="rotate(-64.41 974.836 514.14)"
                />
                <path
                    className="error502__cls-3"
                    d="M915.45 533.94l-11.54-5.44-3.34 6.89a28.82 28.82 0 00-9.6-.51l-2.57-7.2-12.07 4.2 2.57 7.2a28.76 28.76 0 00-7.16 6.34l-7-3.29-5.53 11.38 7 3.3a27.87 27.87 0 00-.52 9.48l-7.3 2.54 4.25 11.9 7.3-2.54a28.09 28.09 0 006.42 7.06l-3.36 6.89 11.54 5.45 3.34-6.89a28.82 28.82 0 009.6.5l2.57 7.21 12.07-4.2-2.56-7.21a28.37 28.37 0 007.16-6.34l7 3.3 5.53-11.39-7-3.29a27.87 27.87 0 00.52-9.48l7.3-2.54-4.24-11.91-7.31 2.54a28.26 28.26 0 00-6.42-7.06z"
                />
                <ellipse
                    className="error502__cls-2"
                    cx={894.23}
                    cy={563.04}
                    rx={13.17}
                    ry={13}
                    transform="rotate(-1.72 892.112 561.781)"
                />
                <rect
                    className="error502__cls-3"
                    x={117.13}
                    y={479.44}
                    width={158.41}
                    height={158.41}
                    rx={6.52}
                />
                <path
                    className="error502__cls-3"
                    d="M178.95 602.11h34.77V860.5h-34.77zM886.01 802.06h15.45v57.96h-15.45z"
                />
                <rect
                    className="error502__cls-3"
                    x={701.51}
                    y={642.68}
                    width={89.83}
                    height={217.33}
                    rx={6.52}
                />
                <path
                    className="error502__cls-3"
                    d="M117.13 541.26h-42.5v40.57h3.86v-36.71h38.64v-3.86z"
                />
                <circle
                    className="error502__cls-3"
                    cx={76.07}
                    cy={593.9}
                    r={12.07}
                />
                <path
                    className="error502__cls-3"
                    d="M922.71 778.88h25.38v-24.22h-2.31v21.91h-23.07v2.31z"
                />
                <circle
                    className="error502__cls-3"
                    cx={947.22}
                    cy={747.45}
                    r={7.21}
                />
                <circle
                    className="error502__cls-2"
                    cx={196.33}
                    cy={558.65}
                    r={42.5}
                />
                <circle
                    className="error502__cls-3"
                    cx={196.33}
                    cy={247.62}
                    r={29.94}
                />
                <circle
                    className="error502__cls-3"
                    cx={807.77}
                    cy={249.55}
                    r={14.49}
                />
                <circle
                    className="error502__cls-3"
                    cx={771.06}
                    cy={249.55}
                    r={14.49}
                />
                <circle
                    className="error502__cls-3"
                    cx={293.77}
                    cy={320.55}
                    r={14.49}
                />
                <circle
                    className="error502__cls-3"
                    cx={257.06}
                    cy={320.55}
                    r={14.49}
                />
                <circle
                    className="error502__cls-3"
                    cx={843.5}
                    cy={249.55}
                    r={14.49}
                />
                <circle
                    className="error502__cls-2"
                    cx={745.91}
                    cy={827.36}
                    r={12.47}
                />
                <path
                    className="error502__cls-5"
                    d="M178.95 575.07l34.29-34.29"
                />
                <path
                    className="error502__cls-3"
                    d="M334.94 460.61h46.36v219.28h-46.36zM398.81 850.61c-.85 1.79-4.44-3.89-6.43-3.89s-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-.67-2.1-1.54-3.9c-1.79-3.75-5.17-3-5.17-7.13s5.44-4.16 5.44-8.31-5.11-4.16-5.11-8.32 5.44-4.15 5.44-8.31S318 812 318 807.88s5.44-4.16 5.44-8.32-5.44-4.15-5.44-8.31 5.44-4.16 5.44-8.31-5.44-4.16-5.44-8.32 5.44-4.15 5.44-8.31S318 762.15 318 758s5.44-4.15 5.44-8.31-5.44-4.16-5.44-8.31 5.44-4.16 5.44-8.32-5.44-4.16-5.44-8.32 5.44-4.16 5.44-8.32-5.44-4.16-5.44-8.31 5.44-4.17 5.44-8.33-7-5.74-5.17-9.49c.85-1.8 4.44 3.89 6.43 3.89s2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44.67 2.1 1.54 3.9c1.8 3.75 5.17 3 5.17 7.13s-5.44 4.16-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.15 5.44 8.31-5.44 4.16-5.44 8.32 5.44 4.15 5.44 8.31-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.31-5.44 4.16-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.16-5.44 8.32 5.44 4.16 5.44 8.31-6.53 5.13-5.32 9.11c1.14 4.9 6.52 4.96 4.72 8.71z"
                />
                <path
                    d="M398.81 850.61c-.85 1.79-4.44-3.89-6.43-3.89s-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-.67-2.1-1.54-3.9c-1.79-3.75-5.17-3-5.17-7.13s5.44-4.16 5.44-8.31-5.11-4.16-5.11-8.32 5.44-4.15 5.44-8.31S318 812 318 807.88s5.44-4.16 5.44-8.32-5.44-4.15-5.44-8.31 5.44-4.16 5.44-8.31-5.44-4.16-5.44-8.32 5.44-4.15 5.44-8.31S318 762.15 318 758s5.44-4.15 5.44-8.31-5.44-4.16-5.44-8.31 5.44-4.16 5.44-8.32-5.44-4.16-5.44-8.32 5.44-4.16 5.44-8.32-5.44-4.16-5.44-8.31 5.44-4.17 5.44-8.33-7-5.74-5.17-9.49c.85-1.8 4.44 3.89 6.43 3.89s2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44.67 2.1 1.54 3.9c1.8 3.75 5.17 3 5.17 7.13s-5.44 4.16-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.15 5.44 8.31-5.44 4.16-5.44 8.32 5.44 4.15 5.44 8.31-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.31-5.44 4.16-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.16-5.44 8.32 5.44 4.16 5.44 8.31-6.53 5.13-5.32 9.11c1.14 4.9 6.52 4.96 4.72 8.71z"
                    strokeWidth={2.52}
                    strokeMiterlimit={10}
                    stroke="#c0f0e8"
                    fill="none"
                />
                <path
                    className="error502__cls-3"
                    d="M296.95 679.88H419.3v12.06H296.95zM287.17 846.51h126.67V859H287.17zM244.15 452.28h227.96V461H244.15zM244.36 451.86a21.24 21.24 0 1142.48 0M429.41 451.86a21.24 21.24 0 1142.48 0M725 646a21.24 21.24 0 1142.48 0M521.18 215.2a13.86 13.86 0 1127.72 0M182.13 224.44c0-9.06 6.21-16.4 13.86-16.4s13.87 7.34 13.87 16.4M555 215.2a13.86 13.86 0 1127.72 0M683.45 215.2a21.11 21.11 0 1142.21 0M812.59 358.7c0-38.94 31.06-70.51 69.38-70.51s69.37 31.57 69.37 70.51"
                />
                <path
                    className="error502__cls-3"
                    d="M324 452.58c-8.57-11.52-13.85-28.93-13.85-46.23 0-35.36 22.06-64 49.28-64s49.28 28.68 49.28 64c0 18.55-6.06 35.25-15.75 46.94"
                />
                <path
                    className="error502__cls-7"
                    d="M356.59 453.72a56.51 56.51 0 005.23-29.15 24.06 24.06 0 00-2.05-8.84 10.56 10.56 0 00-6.67-5.73c-3-.7-6.43.61-7.71 3.37-1 2.23-.5 4.89.53 7.11 1.43 3.1 4 5.85 7.33 6.59 5.34 1.19 10.42-3.1 13.19-7.84 3.78-6.47 5.09-14.16 4.95-21.66s-1.64-14.89-3.14-22.24"
                />
                <circle
                    className="error502__cls-2"
                    cx={893.73}
                    cy={775.02}
                    r={9.98}
                />
                <path className="error502__cls-5" d="M707.27 277.56v60.86" />
                <rect
                    className="error502__cls-3"
                    x={511.71}
                    y={215.26}
                    width={222.16}
                    height={61.82}
                    rx={6.52}
                />
                <rect
                    className="error502__cls-2"
                    x={533.92}
                    y={234.58}
                    width={173.87}
                    height={26.08}
                    rx={10.94}
                />
                <path
                    className="error502__cls-5"
                    d="M548.9 242.62c3.38 0 3.38 10 6.76 10s3.37-10 6.75-10 3.38 10 6.76 10 3.38-10 6.76-10 3.38 10 6.76 10 3.38-10 6.76-10 3.38 10 6.76 10 3.38-10 6.76-10 3.38 10 6.76 10 3.38-10 6.76-10 3.39 10 6.77 10 3.38-10 6.76-10 3.38 10 6.76 10 3.38-10 6.76-10 3.38 10 6.76 10 3.38-10 6.76-10 3.38 10 6.76 10 3.38-10 6.76-10 3.39 10 6.77 10 3.38-10 6.77-10 3.38 10 6.77 10"
                />
                <path
                    className="error502__cls-2"
                    d="M720.96 666H737v28.51h-16.04zM754.82 666h16.04v28.51h-16.04zM720.96 711.44H737v28.51h-16.04zM754.82 711.44h16.04v28.51h-16.04zM720.96 756.88H737v28.51h-16.04zM754.82 756.88h16.04v28.51h-16.04z"
                />
                <path
                    className="error502__cls-3"
                    d="M513.23 235.06H184.26v247.76h21.25V256.31h307.72v-21.25z"
                />
                <path
                    className="error502__cls-7"
                    d="M709.86 860.41V658.59a5.58 5.58 0 015.58-5.59h62a5.59 5.59 0 015.59 5.59v201.82"
                />
                <circle
                    className="error502__cls-7"
                    cx={745.91}
                    cy={827.36}
                    r={21.09}
                />
                <path
                    className="error502__cls-7"
                    d="M126 511v-15.91a8.09 8.09 0 018.09-8.09H149"
                />
                <circle
                    className="error502__cls-7"
                    cx={195.33}
                    cy={247.62}
                    r={16.38}
                />
                <path
                    className="error502__cls-7"
                    d="M833.35 342c0-19.88 20-36 44.79-36s44.8 16.12 44.8 36"
                />
                <path
                    className="error502__cls-3"
                    d="M659 756.32l-10.16-4.63c10.59-23.26 12.25-41.94 4.93-55.5-9.36-17.35-30.92-20.87-31.14-20.91l1.67-11c1.1.17 27.16 4.3 39.25 26.54 9.17 16.77 7.64 38.83-4.55 65.5z"
                />
                <path
                    className="error502__cls-3"
                    d="M664.77 777.66l-7.78-3a11.25 11.25 0 10-21-8l-7.78-3a19.57 19.57 0 0136.57 14zM443.31 752.58l10.16-4.64c-10.59-23.26-12.25-41.93-4.93-55.5 9.36-17.35 30.92-20.87 31.14-20.9l-1.67-11c-1.1.16-27.16 4.29-39.25 26.54-9.13 16.77-7.6 38.82 4.55 65.5z"
                />
                <path
                    className="error502__cls-3"
                    d="M437.58 773.91l7.78-3a11.24 11.24 0 1121-8l7.78-3a19.57 19.57 0 00-36.57 14z"
                />
                <path
                    className="error502__cls-3"
                    transform="rotate(144.14 646.36 765.264)"
                    d="M642.18 746.58h8.32v37.44h-8.32z"
                />
                <path
                    className="error502__cls-3"
                    d="M667 800.87L659.15 790a1.52 1.52 0 01.34-2.14l4.84-3.5a1.54 1.54 0 012.14.35l7.84 10.85a1.1 1.1 0 001.87-.16 13.54 13.54 0 10-9.91 7.18 1.1 1.1 0 00.73-1.71z"
                />
                <path
                    className="error502__cls-3"
                    d="M453.79 744.83h7.83a3.43 3.43 0 013.43 3.43v26.54a1.37 1.37 0 01-1.37 1.37h-11.95a1.37 1.37 0 01-1.37-1.37v-26.55a3.43 3.43 0 013.43-3.42z"
                    transform="rotate(21.67 457.636 760.35)"
                />
                <path
                    className="error502__cls-3"
                    transform="rotate(21.67 468.02 734.233)"
                    d="M465.98 720.08h4.2v28.58h-4.2z"
                />
                <path
                    className="error502__cls-3"
                    d="M476.77 722.45l-6.82-2.72 4.03-7.32 4.88 1.94-2.09 8.1z"
                />
                <path
                    className="error502__cls-3"
                    transform="rotate(21.67 463.944 744.492)"
                    d="M459.28 743.27h9.44v2.77h-9.44z"
                />
                <rect
                    className="error502__cls-3"
                    x={727}
                    y={524}
                    width={80}
                    height={59}
                    rx={9.09}
                />
                <rect
                    className="error502__cls-2"
                    x={740}
                    y={537}
                    width={54}
                    height={33}
                    rx={5.58}
                />
                <path
                    className="error502__cls-5"
                    d="M753.43 565.29a20.33 20.33 0 01-.3-13.16A15.27 15.27 0 01772.51 542a12.76 12.76 0 017.88 16 9.77 9.77 0 01-12.4 6.5 8.17 8.17 0 01-5-10.23 6.24 6.24 0 017.93-4.16 5.23 5.23 0 013.23 6.55"
                />
                <path
                    className="error502__cls-3"
                    d="M745 524.32a21.24 21.24 0 1142.48 0"
                />
            </g>
            <g id="error502__Layer_4" data-name="Layer 4">
                <path
                    className="error502__cls-2"
                    d="M363.92 306.06h376.76a11.06 11.06 0 0111.06 11.06V693a11.06 11.06 0 01-11.06 11H363.92a10.15 10.15 0 01-10.15-10.15V316.2a10.15 10.15 0 0110.15-10.14z"
                />
                <g clipPath="url(#error502__clip-path)">
                    <circle
                        className="error502__cls-3"
                        cx={773.96}
                        cy={749.9}
                        r={71.48}
                    />
                    <circle cx={773.96} cy={749.9} r={50.23} fill="#fff" />
                    <rect
                        className="error502__cls-10"
                        x={701.51}
                        y={642.68}
                        width={89.83}
                        height={217.33}
                        rx={6.52}
                    />
                    <circle
                        className="error502__cls-2"
                        cx={745.91}
                        cy={827.36}
                        r={12.47}
                    />
                    <path
                        className="error502__cls-10"
                        d="M334.94 460.61h46.36v219.28h-46.36z"
                    />
                    <path
                        className="error502__cls-11"
                        d="M398.81 850.61c-.85 1.79-4.44-3.89-6.43-3.89s-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-.67-2.1-1.54-3.9c-1.79-3.75-5.17-3-5.17-7.13s5.44-4.16 5.44-8.31-5.11-4.16-5.11-8.32 5.44-4.15 5.44-8.31S318 812 318 807.88s5.44-4.16 5.44-8.32-5.44-4.15-5.44-8.31 5.44-4.16 5.44-8.31-5.44-4.16-5.44-8.32 5.44-4.15 5.44-8.31S318 762.15 318 758s5.44-4.15 5.44-8.31-5.44-4.16-5.44-8.31 5.44-4.16 5.44-8.32-5.44-4.16-5.44-8.32 5.44-4.16 5.44-8.32-5.44-4.16-5.44-8.31 5.44-4.17 5.44-8.33-7-5.74-5.17-9.49c.85-1.8 4.44 3.89 6.43 3.89s2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44.67 2.1 1.54 3.9c1.8 3.75 5.17 3 5.17 7.13s-5.44 4.16-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.15 5.44 8.31-5.44 4.16-5.44 8.32 5.44 4.15 5.44 8.31-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.31-5.44 4.16-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.16-5.44 8.32 5.44 4.16 5.44 8.31-6.53 5.13-5.32 9.11c1.14 4.9 6.52 4.96 4.72 8.71z"
                    />
                    <path
                        d="M398.81 850.61c-.85 1.79-4.44-3.89-6.43-3.89s-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-2-5.44-4-5.44-2 5.44-4 5.44-.67-2.1-1.54-3.9c-1.79-3.75-5.17-3-5.17-7.13s5.44-4.16 5.44-8.31-5.11-4.16-5.11-8.32 5.44-4.15 5.44-8.31S318 812 318 807.88s5.44-4.16 5.44-8.32-5.44-4.15-5.44-8.31 5.44-4.16 5.44-8.31-5.44-4.16-5.44-8.32 5.44-4.15 5.44-8.31S318 762.15 318 758s5.44-4.15 5.44-8.31-5.44-4.16-5.44-8.31 5.44-4.16 5.44-8.32-5.44-4.16-5.44-8.32 5.44-4.16 5.44-8.32-5.44-4.16-5.44-8.31 5.44-4.17 5.44-8.33-7-5.74-5.17-9.49c.85-1.8 4.44 3.89 6.43 3.89s2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44 2 5.44 4 5.44 2-5.44 4-5.44.67 2.1 1.54 3.9c1.8 3.75 5.17 3 5.17 7.13s-5.44 4.16-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.15 5.44 8.31-5.44 4.16-5.44 8.32 5.44 4.15 5.44 8.31-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.15-5.44 8.31 5.44 4.16 5.44 8.31-5.44 4.16-5.44 8.31 5.44 4.16 5.44 8.32-5.44 4.16-5.44 8.32 5.44 4.16 5.44 8.31-6.53 5.13-5.32 9.11c1.14 4.9 6.52 4.96 4.72 8.71z"
                        stroke="#e94d72"
                        strokeWidth={2.52}
                        strokeMiterlimit={10}
                        fill="none"
                    />
                    <rect
                        className="error502__cls-13"
                        x={296.95}
                        y={679.88}
                        width={122.35}
                        height={12.12}
                        rx={2.12}
                    />
                    <path
                        className="error502__cls-13"
                        d="M244.15 452.28h227.96V461H244.15zM429.41 452.86a21.24 21.24 0 1142.48 0"
                    />
                    <path
                        className="error502__cls-11"
                        d="M725 642a21.24 21.24 0 1142.48 0M324 452.58c-8.57-11.52-13.85-28.93-13.85-46.23 0-35.36 22.06-64 49.28-64s49.28 28.68 49.28 64c0 18.55-6.06 35.25-15.75 46.94"
                    />
                    <path
                        className="error502__cls-7"
                        d="M356.59 453.72a56.51 56.51 0 005.23-29.15 24.06 24.06 0 00-2.05-8.84 10.56 10.56 0 00-6.67-5.73c-3-.7-6.43.61-7.71 3.37-1 2.23-.5 4.89.53 7.11 1.43 3.1 4 5.85 7.33 6.59 5.34 1.19 10.42-3.1 13.19-7.84 3.78-6.47 5.09-14.16 4.95-21.66s-1.64-14.89-3.14-22.24"
                    />
                    <path
                        className="error502__cls-2"
                        d="M720.96 666H737v28.51h-16.04zM754.82 666h16.04v28.51h-16.04zM720.96 711.44H737v28.51h-16.04zM754.82 711.44h16.04v28.51h-16.04zM720.96 756.88H737v28.51h-16.04zM754.82 756.88h16.04v28.51h-16.04z"
                    />
                    <path
                        className="error502__cls-7"
                        d="M709.86 860.41V658.59a5.58 5.58 0 015.58-5.59h62a5.59 5.59 0 015.59 5.59v201.82"
                    />
                    <circle
                        className="error502__cls-7"
                        cx={745.91}
                        cy={827.36}
                        r={21.09}
                    />
                    <path
                        d="M563.39 459.16L687.16 330a13.52 13.52 0 0117.31-4.6h0a13.52 13.52 0 017.37 13.88l-43.17 186.53"
                        strokeWidth={1.93}
                        strokeMiterlimit={10}
                        fill="none"
                        stroke="#2e3142"
                    />
                    <path
                        className="error502__cls-11"
                        d="M693.79 506.4v-27.83H677a61.85 61.85 0 00-8-19.32l11.91-11.91-19.68-19.68-11.91 11.91a61.85 61.85 0 00-19.32-8v-16.85h-27.89v16.84a62.05 62.05 0 00-19.32 8l-11.91-11.91-19.67 19.68 11.91 11.91a61.85 61.85 0 00-8 19.32h-16.85v27.84h16.84a61.9 61.9 0 008 19.31l-11.91 11.91 19.67 19.68 11.91-11.91a62.05 62.05 0 0019.32 8v16.84h27.83V553.4a61.85 61.85 0 0019.32-8l11.91 11.91 19.68-19.68-11.91-11.91a61.9 61.9 0 008-19.31z"
                    />
                    <circle
                        className="error502__cls-2"
                        cx={616.03}
                        cy={492.48}
                        r={28.65}
                    />
                    <path
                        className="error502__cls-11"
                        d="M519.17 497l-18.59-8.9-5.38 11.24a45.93 45.93 0 00-15.47-.83l-4.14-11.76-19.44 6.85 4.15 11.76a46.21 46.21 0 00-11.53 10.34l-11.25-5.38-8.9 18.59 11.24 5.38a46.19 46.19 0 00-.82 15.47l-11.77 4.15 6.85 19.43 11.77-4.14a46 46 0 0010.34 11.53L450.84 592l18.59 8.9 5.39-11.24a45.87 45.87 0 0015.46.83l4.15 11.76 19.44-6.85-4.15-11.76a46.05 46.05 0 0011.53-10.35l11.25 5.39 8.9-18.59-11.25-5.38a45.93 45.93 0 00.83-15.47l11.76-4.15-6.85-19.43-11.76 4.14a46 46 0 00-10.34-11.53z"
                    />
                    <circle
                        className="error502__cls-2"
                        cx={485.01}
                        cy={544.5}
                        r={21.22}
                    />
                    <circle
                        className="error502__cls-13"
                        cx={487.84}
                        cy={356.77}
                        r={14.49}
                    />
                    <circle
                        className="error502__cls-13"
                        cx={451.13}
                        cy={356.77}
                        r={14.49}
                    />
                    <circle
                        className="error502__cls-13"
                        cx={523.58}
                        cy={356.77}
                        r={14.49}
                    />
                    <circle
                        className="error502__cls-13"
                        cx={558.35}
                        cy={356.77}
                        r={14.49}
                    />
                    <circle
                        className="error502__cls-13"
                        cx={592.16}
                        cy={356.77}
                        r={14.49}
                    />
                    <circle
                        className="error502__cls-10"
                        cx={698.13}
                        cy={337.93}
                        r={10.14}
                    />
                    <circle
                        className="error502__cls-13"
                        cx={663.4}
                        cy={606.63}
                        r={14.49}
                    />
                    <circle
                        className="error502__cls-13"
                        cx={699.14}
                        cy={606.63}
                        r={14.49}
                    />
                    <path
                        className="error502__cls-13"
                        d="M659 756.32l-10.16-4.63c10.59-23.26 12.25-41.94 4.93-55.5-9.36-17.35-30.92-20.87-31.14-20.91l1.67-11c1.1.17 27.16 4.3 39.25 26.54 9.17 16.77 7.64 38.83-4.55 65.5z"
                    />
                    <path
                        className="error502__cls-13"
                        d="M664.77 777.66l-7.78-3a11.25 11.25 0 10-21-8l-7.78-3a19.57 19.57 0 0136.57 14zM443.31 752.58l10.16-4.64c-10.59-23.26-12.25-41.93-4.93-55.5 9.36-17.35 30.92-20.87 31.14-20.9l-1.67-11c-1.1.16-27.16 4.29-39.25 26.54-9.13 16.77-7.6 38.82 4.55 65.5z"
                    />
                    <path
                        className="error502__cls-13"
                        d="M437.58 773.91l7.78-3a11.24 11.24 0 1121-8l7.78-3a19.57 19.57 0 00-36.57 14z"
                    />
                    <rect
                        className="error502__cls-10"
                        x={727}
                        y={524}
                        width={80}
                        height={59}
                        rx={9.09}
                    />
                    <rect
                        className="error502__cls-2"
                        x={740}
                        y={537}
                        width={54}
                        height={33}
                        rx={5.58}
                    />
                    <path
                        d="M753.43 565.29a20.33 20.33 0 01-.3-13.16A15.27 15.27 0 01772.51 542a12.76 12.76 0 017.88 16 9.77 9.77 0 01-12.4 6.5 8.17 8.17 0 01-5-10.23 6.24 6.24 0 017.93-4.16 5.23 5.23 0 013.23 6.55"
                        strokeWidth={1.97}
                        fill="none"
                        strokeMiterlimit={15}
                        stroke="#2e3142"
                    />
                    <path
                        className="error502__cls-13"
                        d="M745 524.32a21.24 21.24 0 1142.48 0"
                    />
                </g>
                <path
                    d="M363.92 306.06h376.76a11.06 11.06 0 0111.06 11.06V693a11.06 11.06 0 01-11.06 11H363.92a10.15 10.15 0 01-10.15-10.15V316.2a10.15 10.15 0 0110.15-10.14z"
                    fill="none"
                    strokeWidth={6}
                    strokeMiterlimit={15}
                    stroke="#2e3142"
                />
                <path
                    className="error502__cls-10"
                    d="M482.47 643.06H623a5.5 5.5 0 015.5 5.5V701H477v-52.43a5.5 5.5 0 015.47-5.51z"
                />
                <path
                    className="error502__cls-13"
                    d="M503.62 672v99.49H490.1v30h18.51a19.16 19.16 0 0019.16-19.16V672z"
                />
                <ellipse
                    className="error502__cls-10"
                    cx={493.96}
                    cy={794.96}
                    rx={16.9}
                    ry={25.36}
                />
                <path
                    className="error502__cls-13"
                    d="M579.93 672v99.49H566.4v30h18.52a19.16 19.16 0 0019.16-19.16V672z"
                />
                <ellipse
                    className="error502__cls-10"
                    cx={570.27}
                    cy={794.96}
                    rx={16.9}
                    ry={25.36}
                />
                <path
                    stroke="#000"
                    strokeWidth={2}
                    strokeMiterlimit={10}
                    fill="none"
                    d="M24 860h1029"
                />
                <path
                    className="error502__cls-10"
                    d="M225.47 727.56h27.89v15.93h-27.89z"
                />
                <path
                    className="error502__cls-11"
                    d="M159.27 735.52h161.28A10.48 10.48 0 01331 746v45.29H148.79V746a10.48 10.48 0 0110.48-10.48z"
                />
                <path
                    d="M165.18 742.5h149.46a9.42 9.42 0 019.42 9.42v39.37h0-168.3 0v-39.37a9.42 9.42 0 019.42-9.42z"
                    strokeWidth={2.51}
                    stroke="#ebfaf6"
                    strokeMiterlimit={10}
                    fill="#ebfaf6"
                />
                <path
                    className="error502__cls-10"
                    transform="rotate(-.06 219.239 754.51)"
                    d="M221.96 771.1h6.1v33.15h-6.1z"
                />
                <path
                    className="error502__cls-10"
                    d="M228.32 751.45v11.85a1.29 1.29 0 01-1.24 1.36h-4.87a1.3 1.3 0 01-1.26-1.35v-11.86a.9.9 0 00-1.31-.86 12.21 12.21 0 00-6 11.76c.45 5.62 4.59 10.23 9.76 10.85 6.68.8 12.32-4.86 12.31-11.93a12.11 12.11 0 00-6.08-10.69.9.9 0 00-1.31.87zM252.5 771.23h6.59v33.01h-6.59z"
                />
                <path
                    className="error502__cls-10"
                    d="M255.74 749.87a12.35 12.35 0 1012.34 12.34 12.34 12.34 0 00-12.34-12.34zm4.07 19.4h-8.14l-4.07-7.06 4.07-7.05h8.14l4.07 7.05z"
                />
                <path
                    className="error502__cls-10"
                    d="M169.14 786.17h7.8a3.41 3.41 0 013.41 3.41V816a1.36 1.36 0 01-1.36 1.36h-11.9a1.36 1.36 0 01-1.36-1.36v-26.41a3.41 3.41 0 013.41-3.41z"
                    transform="rotate(-.14 179.062 826.916)"
                />
                <path
                    className="error502__cls-10"
                    transform="rotate(-.14 179.097 798.268)"
                    d="M170.88 759.55h4.18v28.46h-4.18z"
                />
                <path
                    className="error502__cls-10"
                    d="M176.59 759.54l-7.31.02 1.02-8.26 5.22-.02 1.07 8.26z"
                />
                <path
                    className="error502__cls-10"
                    transform="rotate(-.14 179.082 810.546)"
                    d="M168.29 783.42h9.4v2.75h-9.4z"
                />
                <path
                    className="error502__cls-10"
                    d="M193 786.17h7.8a3.41 3.41 0 013.41 3.41V816a1.36 1.36 0 01-1.36 1.36H191a1.36 1.36 0 01-1.36-1.36v-26.41a3.41 3.41 0 013.41-3.41z"
                    transform="rotate(-.14 203.618 826.946)"
                />
                <path
                    className="error502__cls-10"
                    transform="rotate(-.14 203.653 798.298)"
                    d="M194.78 759.55h4.18v28.46h-4.18z"
                />
                <path
                    className="error502__cls-10"
                    d="M200.49 759.54l-7.31.02 3.01-8.26 1.24-.02 3.06 8.26z"
                />
                <path
                    className="error502__cls-10"
                    transform="rotate(-.14 203.638 810.576)"
                    d="M192.2 783.42h9.4v2.75h-9.4z"
                />
                <path
                    className="error502__cls-10"
                    d="M289.59 767.56h7.44v37.29h-7.44z"
                />
                <path
                    className="error502__cls-10"
                    d="M302.5 760v5.42a2.51 2.51 0 01-2.76 2.76h-12.16a2.5 2.5 0 01-2.76-2.76v-12.13a2.5 2.5 0 012.76-2.76h14.92c4.64-.07 11.82 3.75 12.59 13.37a1.9 1.9 0 01-2.1 2.32h-1.76c-1.33 0-2-.78-2.22-2.22a5.55 5.55 0 00-6.51-4z"
                />
                <path
                    className="error502__cls-10"
                    d="M282.24 755.94h2.99v6.97h-2.99z"
                />
                <rect
                    className="error502__cls-10"
                    x={276.26}
                    y={750.46}
                    width={5.98}
                    height={17.93}
                    rx={1.02}
                />
                <path
                    className="error502__cls-11"
                    d="M143.31 791.29h193.21a3.48 3.48 0 013.48 3.48v39.08A29.14 29.14 0 01310.86 863H169a29.14 29.14 0 01-29.14-29.14v-39.08a3.48 3.48 0 013.45-3.49z"
                />
                <path
                    className="error502__cls-2"
                    d="M186.63 791.29h13.94v21.91h-13.94zM199.58 814.2v4h-12v-4h12m1-1h-13.95v6h13.94v-6zM271.28 791.29h13.94v21.91h-13.94zM284.23 814.2v4h-12v-4h12m1-1h-14v6h14v-6z"
                />
                <path
                    d="M335 799.43v32.23A26.36 26.36 0 01308.66 858h-137.5a26.36 26.36 0 01-26.36-26.36v-32.21"
                    strokeWidth={1.99}
                    stroke="#ebfaf6"
                    strokeMiterlimit={10}
                    fill="none"
                />
            </g>
        </svg>
    );
}
